export const MASTER_API_URL = 'https://prod-api.wizzflix.com/api/'
